export const userUrlAccount = 'https://myaccount.microsoft.com/?ref=MeControl';
